const initialState = {
  errors: new Map(),
}

export function statusReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_ERRORS':
      return {
        ...state,
        errors: new Map([...state.errors, [action.id, action.errors]]),
      };
    case 'CLEAR_ERROR':
      state.errors.delete(action.id);
      return {
        ...state,
        errors: new Map(...state.errors),
      };
    default:
      return state;
  }
}
